import type { TOC } from '@ember/component/template-only';

interface BlankColumnSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default <template>
  <div class="table-cell border-b align-middle px-2 text-carbon-50" ...attributes>
    {{yield}}
  </div>
</template> satisfies TOC<BlankColumnSignature>;
